/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ProductCatalog_Products } from '../models/Gsoa_ProductCatalog_Products';
import type { ThisAndThat_CollectEvent } from '../models/ThisAndThat_CollectEvent';
import type { ThisAndThat_ProductsForProduct } from '../models/ThisAndThat_ProductsForProduct';
import type { ThisAndThat_ProductsOnSale } from '../models/ThisAndThat_ProductsOnSale';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ThisAndThatService {
    /**
     * Returns VANRs recommended for the current customer by the FoodRetailor Content API.
     * Without a strategy it maps the home-page `onSale` slot; strategy=bonus maps the `bonus` slot.
     * The response shape remains compatible with the original ThisAndThat endpoint.
     * @returns ThisAndThat_ProductsOnSale Successful loading.
     * @throws ApiError
     */
    public static thisAndThatGetProductsOnSale({
        marketId,
        apiVersion = 1,
        strategy = '',
        minScore,
        vanr,
    }: {
        /**
         * Market (house) number.
         */
        marketId: number,
        apiVersion?: number,
        /**
         * Home-page slot selector. Empty (default) returns the `onSale` slot and `bonus` returns
         * the `bonus` slot. It is retained on product-detail endpoints for backwards compatibility.
         */
        strategy?: string,
        /**
         * Deprecated backwards-compatible parameter; ignored by the FoodRetailor Content API adapter.
         * @deprecated
         */
        minScore?: number,
        /**
         * Product VANR used to filter productsOnSale recommendations to other items with the same
         * FoodRetailor product card. The selected VANR itself is omitted from the response.
         */
        vanr?: string,
    }): CancelablePromise<ThisAndThat_ProductsOnSale> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/thisAndThat/recommend/customer/productsOnSale/{marketId}',
            path: {
                'apiVersion': apiVersion,
                'marketId': marketId,
            },
            query: {
                'strategy': strategy,
                'minScore': minScore,
                'vanr': vanr,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns FoodRetailor recommendations enriched with full product data from GSOA Product Catalog.
     * Only in-stock products are returned; missing products are back-filled from further VANR pages
     * so the response matches the requested pageSize. Each recommended product contains `thisAndThat`
     * tracking metadata copied from its FoodRetailor product card.
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static thisAndThatGetProductsOnSaleCatalog({
        marketId,
        apiVersion = 1,
        strategy = '',
        minScore,
        vanr,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filterProductsCatalog,
        page,
        pageSize = 50,
    }: {
        /**
         * Market (house) number.
         */
        marketId: number,
        apiVersion?: number,
        /**
         * Home-page slot selector. Empty (default) returns the `onSale` slot and `bonus` returns
         * the `bonus` slot. It is retained on product-detail endpoints for backwards compatibility.
         */
        strategy?: string,
        /**
         * Deprecated backwards-compatible parameter; ignored by the FoodRetailor Content API adapter.
         * @deprecated
         */
        minScore?: number,
        /**
         * Product VANR used to filter productsOnSale recommendations to other items with the same
         * FoodRetailor product card. The selected VANR itself is omitted from the response.
         */
        vanr?: string,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filterProductsCatalog?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/thisAndThat/recommend/customer/productsOnSaleCatalog/{marketId}',
            path: {
                'apiVersion': apiVersion,
                'marketId': marketId,
            },
            query: {
                'strategy': strategy,
                'minScore': minScore,
                'vanr': vanr,
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter-productsCatalog': filterProductsCatalog,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the product-detail `top` slot as a backwards-compatible raw list of product variant groups.
     * @returns ThisAndThat_ProductsForProduct Successful loading.
     * @throws ApiError
     */
    public static thisAndThatGetProductsForProduct({
        productId,
        marketId,
        apiVersion = 1,
        strategy = '',
        minScore,
    }: {
        /**
         * Product VANR (or product identifier).
         */
        productId: string,
        /**
         * Market (house) number.
         */
        marketId: number,
        apiVersion?: number,
        /**
         * Home-page slot selector. Empty (default) returns the `onSale` slot and `bonus` returns
         * the `bonus` slot. It is retained on product-detail endpoints for backwards compatibility.
         */
        strategy?: string,
        /**
         * Deprecated backwards-compatible parameter; ignored by the FoodRetailor Content API adapter.
         * @deprecated
         */
        minScore?: number,
    }): CancelablePromise<ThisAndThat_ProductsForProduct> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/thisAndThat/recommend/customer/product/{productId}/{marketId}',
            path: {
                'apiVersion': apiVersion,
                'productId': productId,
                'marketId': marketId,
            },
            query: {
                'strategy': strategy,
                'minScore': minScore,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Custom endpoint for the "Více Druhů" widget. Products from the FoodRetailor product-detail
     * `top` slot are enriched from GSOA Product Catalog. Products whose product card contains
     * multiple VANRs carry the `vMoreVariants` badge. Only in-stock products are returned.
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static thisAndThatGetMoreVariants({
        productId,
        marketId,
        apiVersion = 1,
        strategy = '',
        minScore,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
    }: {
        /**
         * Product VANR (or product identifier).
         */
        productId: string,
        /**
         * Market (house) number.
         */
        marketId: number,
        apiVersion?: number,
        /**
         * Home-page slot selector. Empty (default) returns the `onSale` slot and `bonus` returns
         * the `bonus` slot. It is retained on product-detail endpoints for backwards compatibility.
         */
        strategy?: string,
        /**
         * Deprecated backwards-compatible parameter; ignored by the FoodRetailor Content API adapter.
         * @deprecated
         */
        minScore?: number,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/thisAndThat/recommend/customer/moreVariants/{productId}/{marketId}',
            path: {
                'apiVersion': apiVersion,
                'productId': productId,
                'marketId': marketId,
            },
            query: {
                'strategy': strategy,
                'minScore': minScore,
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
            },
            errors: {
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Sends an event to the ThisAndThat event collector (analytics).
     * @returns any Event accepted.
     * @throws ApiError
     */
    public static thisAndThatCollectEvent({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: ThisAndThat_CollectEvent,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/thisAndThat/event/collect',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
